import { CurrencyCode } from '@/models/core/currency';
import { UsdtNetworkType } from '@/models/finance/crypto';

export interface AccountInterface {
    name: string;
    number: string;
    id: number;
    currency: string;
    isFiat: boolean;
    cryptoSystem: string | null;
    availBalance: number;
    isCardsPro: boolean;
}

export class Account implements AccountInterface, Record<string, any> {
    name = '';

    number = '';

    currency = '';

    id = 0;

    cryptoSystem = null;

    isFiat = true;

    availBalance = 0;

    isCardsPro = false;

    _internalCurrency: string | null = null;

    static createFromData(data?: any): Account {
      return Object.assign(new Account(), data);
    }

    get isCrypto(): boolean {
      return !this.isFiat;
    }

    get hasCryptoSystem(): boolean {
      return Boolean(this.isCrypto && this.cryptoSystem);
    }

    get internalCurrency() {
      if (this._internalCurrency)
        return this._internalCurrency;

      if (this.currency === CurrencyCode.USDT) {
        return this.cryptoSystem === UsdtNetworkType.Tron ? CurrencyCode.USDTt : CurrencyCode.USDT;
      }
      return this.currency;
    }

    set internalCurrency(value: string | null) {
      this._internalCurrency = value;
    }
}
